<template>
  <div class="m-0 px-0 py-0">
    <div class="row d-flex flex-row px-0 mx-0">
      <div class="col=12 w-100 my-0" v-if="!loading">
        <div class="row mt-3 mb-2 ml-0">

          <div class="container-fluid w-100 mb-3 p-3 border bg-white rounded stats-wrapper">
            <div class="row">

              <!-- Filter Contact Name -->
              <div class="col-12 col-md-3">
                <div class="input-group input-group-sm p-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Contact Name</span>
                  </div>
                  <input
                    class="form-control"
                    v-model="model.contact_name"
                    placeholder="Contact Name"
                  />
                </div>
              </div>

              <!-- Filter Job Title -->
              <div class="col-12 col-md-3">
                <div class="input-group input-group-sm p-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Job Title</span>
                  </div>
                  <input
                    class="form-control"
                    v-model="model.job_title"
                    placeholder="Job Title"
                  />
                </div>
              </div>

              <!-- Filter Company Name -->
              <div class="col-12 col-md-3">
                <div class="input-group input-group-sm p-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Company Name</span>
                  </div>
                  <input
                    class="form-control"
                    v-model="model.company_name"
                    placeholder="Company Name"
                  />
                </div>
              </div>

              <!-- Filter Phone -->
              <div class="col-12 col-md-3">
                <div class="input-group input-group-sm p-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Phone</span>
                  </div>
                  <input
                    class="form-control"
                    v-model="model.phone"
                    placeholder="Phone"
                  />
                </div>
              </div>

              <!-- Filter Registration Date -->
              <div class="col-12 col-md-9">
                <div class="input-group input-group-sm p-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Registration Date</span>
                  </div>
                  <div class="w-50 input-group input-group-sm px-2">
                    <div class="input-group-prepend">
                      <span class="input-group-text">From</span>
                    </div>
                    <date-picker
                      id="startDatePicker"
                      class="form-control"
                      v-model="model.range.startDate"
                      :config="datePickerConfig"
                      placeholder="Start Date"
                    ></date-picker>
                    <div class="input-group-prepend">
                      <span class="input-group-text">to</span>
                    </div>
                    <date-picker
                      id="endDatePicker"
                      class="form-control"
                      v-model="model.range.endDate"
                      :config="datePickerConfigEndDate"
                      placeholder="End Date"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-12">
                <div class="col-md-12 d-flex justify-content-end my-0">
                  <button
                    class="btn btn-success"
                    :disabled="loading"
                    @click="getData()"
                  >
                    <i class="icon-calendar-check-o mr-2"></i>
                    <small>
                      {{ $t("lang.label.letsgetstarted") }}
                    </small>
                  </button>
                </div>
              </div>

            </div>
          </div>

          <div class="col-12 mx-1 bd-highlight d-flex mb-2">
            {{ $t("lang.label.results") }}:
            <small v-if="!total" class="ml-2 text-primary mr-4">
              {{ $t("lang.search.calculating") }}...
            </small>
            <strong v-else class="ml-2">{{ total }}</strong>
          </div>
        </div>

        <div class="col-12 mt-1 mb-3 text-center">
          <Pagination
            v-if="!loading"
            :total="total"
            :totalpage="phones.length"
            :model="model"
            :limit="false"
            :color="'primary'"
            @changePage="getData(false)"
            key="paginationkey"
          ></Pagination>
        </div>

        <LoadingSpinner v-if="loading" />

        <div class="mx-0 px-0 table-responsive">
          <Table
            v-if="!loading"
            class="mx-0 w-100"
            :headers="headers"
            :cols="cols"
            :checkbox="false"
            :notselect="true"
            :model="[]"
            :data="phones"
            :key="200"
          ></Table>
        </div>
      </div>
    </div>
    <LoadingSpinner v-if="loading" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { adminService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";
import moment from "moment";

export default {
  name: "PhoneDirectory",
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
  },
  data() {
    return {
      phones: [],
      loading: true,
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: true,
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: true,
        maxDate: moment().endOf("day"),
      },
      cols: [
        [{ value: "registration_date" }],
        [{ value: "contact_name" }],
        [{ value: "job_title" }],
        [{ value: "company_name" }],
        [{ value: "phone" }],
      ],
      headers: [
        {
          label: "Registration Date",
          percentage: "20%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Contact Name",
          percentage: "20%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: "Job Title",
          percentage: "20%",
          class: "overflowhide",
          id: 3,
        },
        {
          label: "Company Name",
          percentage: "20%",
          class: "overflowhide",
          id: 4,
        },
        {
          label: "Phone",
          percentage: "20%",
          class: "overflowhide",
          id: 5,
        },
      ],
      total: 0,
      model: {
        contact_name: null,
        job_title: null,
        company_name: null,
        phone: null,
        cantPerPage: 25,
        currentPage: 1,
        range: {
          startDate: "",
          endDate: "",
        },
      },
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Pagination,
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
    }),
    getData(calculateTotal = true) {
      if (calculateTotal) {
        this.model.currentPage = 1;
      }
      this.loading = true;
      const filter = { ...this.model, calculateTotal };
      adminService
        .getPhoneDirectory(filter)
        .then((res) => {
          this.phones = res.phones;
          if (res.total !== null && res.total !== undefined) {
            this.total = parseInt(res.total);
          }
          this.loading = false;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style scoped>
.overflowhide > span {
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}
</style>
